import React from "react";
import { AcceptInspectionTemplate } from "../../Templates/AcceptInspectionTemplate";

export const AcceptInspection = () => {
  return <AcceptInspectionTemplate />;
};
